import { render } from "./AddArticle.vue?vue&type=template&id=b0d0c740&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"

import "./AddArticle.vue?vue&type=style&index=0&id=b0d0c740&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d0c740"]])

export default __exports__